import React from 'react'
import PropTypes from 'prop-types'
import Tooltip, { NoMarkTooltip, NeutralTooltip } from '../TooltipMessage'

const SuccessComponent = ({ successIcon, errorIcon }) => ({ children }) => (
  <Tooltip type='success' successIcon={successIcon} errorIcon={errorIcon}>
    {children}
  </Tooltip>
)

const ErrorComponent = ({ successIcon, errorIcon }) => ({ children }) => (
  <Tooltip type='error' successIcon={successIcon} errorIcon={errorIcon}>
    {children}
  </Tooltip>
)

const NoMarkSuccessComponent = ({ children }) => (
  <NoMarkTooltip type='success'>{children}</NoMarkTooltip>
)

const NoMarkErrorComponent = ({ children }) => (
  <NoMarkTooltip type='error' bigger>
    {children}
  </NoMarkTooltip>
)

const NeutralErrorComponent = ({
  successIcon,
  errorIcon,
  shouldReserveSpace
}) => ({ children }) => (
  <NeutralTooltip
    type='error'
    successIcon={successIcon}
    errorIcon={errorIcon}
    shouldReserveSpace={shouldReserveSpace}
  >
    {children}
  </NeutralTooltip>
)

SuccessComponent.propTypes = {
  successIcon: PropTypes.string,
  errorIcon: PropTypes.string
}

SuccessComponent.defaultProps = {
  successIcon: null,
  errorIcon: null
}

ErrorComponent.propTypes = {
  successIcon: PropTypes.string,
  errorIcon: PropTypes.string
}

ErrorComponent.defaultProps = {
  successIcon: null,
  errorIcon: null
}

NoMarkSuccessComponent.propTypes = {
  children: PropTypes.string
}

NoMarkErrorComponent.propTypes = {
  children: PropTypes.string
}

NeutralErrorComponent.propTypes = {
  successIcon: PropTypes.string,
  errorIcon: PropTypes.string,
  shouldReserveSpace: PropTypes.bool
}

NeutralErrorComponent.defaultProps = {
  successIcon: null,
  errorIcon: null,
  shouldReserveSpace: false
}

export {
  ErrorComponent,
  SuccessComponent,
  NoMarkErrorComponent,
  NoMarkSuccessComponent,
  NeutralErrorComponent
}
